// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2PJCz","col":"styles_col__1Yshv"};